import React, { useEffect, useState } from "react";
import "../css/Mailing.css";
import Footer from "../Common/Footer";
import Header from "../Common/Header";
import Faq from "../Common/Faq";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import PhoneIcon from '@mui/icons-material/Phone';
import axios from "axios";
function Mailing() {


  








  return (
    <>
      <Header />
      <div className="mailing-container font-primary">
        {/* Top Section */}
        <div className="mailing-section mailing-highlight-box">
          <div className="common-container">
            <div className="mailing-text-content">
              <h3 className="mailing-title">
                Streamline Your Mailing Campaigns with <br />
                Powerful Management Tools
              </h3>
              <p className="mailing-description">
                Easily manage and automate your email communications from one
                centralized platform. From contact segmentation to template
                creation and delivery tracking — everything you need to plan,
                send, and optimize your campaigns is right at your fingertips.
              </p>
              <button className="mailing-btn-primary">Get Started Now</button>
            </div>
            <div className="mailing-image-box">
              <img src="./images/mailing-list.png" alt="Mailing Tools" />
            </div>
          </div>
        </div>

        {/* Middle Section */}
        <div className="mailing-section mailing-import-section">
          <div className="common-container">
            <div className="mailing-text-content">
              <h3 className="mailing-subheading">
                Easily Add, Import & Manage Mailing Contacts
              </h3>
              <p className="mailing-description">
                Add mailing contacts manually or save time by importing them in
                bulk using CSV or Excel files. Edit details, remove outdated
                emails, and keep your contact list clean and organized with just
                a few clicks. Whether you're managing hundreds or thousands of
                contacts, our intuitive tools make it simple and efficient.
              </p>
            </div>
            <div className="mailing-image-box">
              <img src="/images/import-mailing.png" alt="Import Contacts" />
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mailing-contact-management">
          <div className="mailing-contact-management-container">
            <h3 className="mailing-subheading">Mailing Contacts Management</h3>
            <div className="mailing-features-grid">
              <div className="mailing-feature-card mailing-split-card ">
                <div className="mailing-icon-box mailing-card-import">
                  <img src="/images/contact-icon.png" alt="Import Contacts" />
                </div>
                <div className="mailing-card-content">
                  <h4>Import Contacts</h4>
                  <p>
                    Skip manual entry and import hundreds of contacts in seconds
                    — perfect for growing your mailing base fast and
                    efficiently.
                  </p>
                </div>
              </div>

              <div className="mailing-feature-card mailing-split-card">
                <div className="mailing-icon-box mailing-card-edit">
                  <img src="/images/mailing-edit.png" alt="Import Contacts" />
                </div>
                <div className="mailing-card-content">
                  <h4>Edit & Update</h4>
                  <p>
                    Easily edit names, emails, tags, or other details anytime to
                    maintain accurate and personalized outreach.
                  </p>
                </div>
              </div>

              <div className="mailing-feature-card mailing-split-card ">
                <div className="mailing-icon-box mailing-card-delete">
                  <img src="/images/mailing-delete.png" alt="Import Contacts" />
                </div>
                <div className="mailing-card-content">
                  <h4>Delete & Organize</h4>
                  <p>
                    Stay organized by cleaning up old emails and managing your
                    lists to improve campaign performance.
                  </p>
                </div>
              </div>
            </div>
            <div className="mailing-cta-buttons">
              <button className="mailing-btn-primary">
                 Get Started Now
                <RocketLaunchIcon className="mailing-btn-icon" />
              </button>

              <button className="mailing-btn-secondary">
                                Contact Now
                <PhoneIcon className="mailing-btn-icon" />
              </button>
              {/* <span className="mailing-join-text">Join Now!</span> */}
            </div>
          </div>
        </div>
      </div>

  <Faq
        endpoint="/api/faq/GetFaqList" // only endpoint, domain comes from .env
        params={{
          currentPage: 1,
          pageSize: 20,
          sortColumn: "FaqId",
          sortDirection: "asc",
          category: "Login Issues"
        }}
      />
      <Footer />
    </>
  );
}

export default Mailing;
